export default function PNRAS() {
  return (
    <div className="bg-gray-50">
      <main className="max-w-7xl mx-auto px-4 py-8">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center bg-white">
          <div className="sm:w-1/2 md:w-1/3 mb-8 sm:mb-0">
            <img
              src="/proiecte/PNRAS/pnrr.jpg"
              alt="PNRAS Banner"
              className="w-full mx-auto sm:mx-0"
            />
          </div>
          <div className="sm:w-1/2 md:w-2/3 ml-0 sm:ml-8 flex items-start">
            <div>
              <h1 className="text-3xl font-bold mb-8 text-left">
                LICEUL TEHNOLOGIC ”DR. FLORIAN ULMEANU” ULMENI
              </h1>
              <p className="mb-4 text-justify font-bold">
                Activitățile desfășurate din cadrul proietului ”Calea spre
                reușită: PNRAS II”
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-700">
                <li>
                  <a
                    href="/proiecte/PNRAS/Activități remediale.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 hover:underline"
                  >
                    Activități remediale
                  </a>
                </li>
                <li>
                  <a
                    href="/proiecte/PNRAS/Activități de prevenire.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 hover:underline"
                  >
                    Activități de prevenire
                  </a>
                </li>
                <li>
                  <a
                    href="/proiecte/PNRAS/workshop.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 hover:underline"
                  >
                    Workshop
                  </a>
                </li>
                <li>
                  <a
                    href="/proiecte/PNRAS/cercurile-tematice"
                    className="text-blue-600 hover:underline"
                  >
                    Cercurile tematice
                  </a>
                </li>
                <li>
                  <a
                    href="/proiecte/PNRAS/activitate 1 decembrie.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 hover:underline"
                  >
                    Activitate cultural-artistic, intitulat "ROMÂNIA, OM ÎN
                    RAI!"
                  </a>
                </li>
                <li>
                  <a
                    href="/proiecte/PNRAS/concert de colinde.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 hover:underline"
                  >
                    Activitate cultura-artistică ”Deschide ușa creștine!”
                    -Concert de colinde
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
